import React from "react";
import Box from "@mui/material/Box";
import {connect} from "react-redux";
import ModuleLoader from "../module-loader";

const mapStateToProps = state => ({
  modulesConfig: state.app.modulesConfig
});

const ModulesPlaceholder = ({modulesConfig, id: placeholderId, moduleFallback, sx, style, ...props}) => (
  <Box id={placeholderId} sx={sx} style={style}>
    {(modulesConfig.placeholders?.[placeholderId] || []).map((module, idx) => (
      <div key={idx} id={`${placeholderId}__${module.id}`}>
        <ModuleLoader
          id={module.id}
          component={module.component}
          fallback={moduleFallback || module.fallback}
          {...props}
        />
      </div>
    ))}
  </Box>
);

export default connect(mapStateToProps)(ModulesPlaceholder);
